window.onload = function () {
  /*
    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'whatsapp' });
                gtag('event', 'click_whatsapp_chat');
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };
    */

  // jQuery is not loaded
  console.info("loading custom scripts for events");

  /**
   * Activacion e incrustación de clases para eventos
   */
  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "telefono",
          event_label: "llamada",
        });
        gtag("event", "click_telefono");
      }
      if (typeof ga == "function") {
        ga("send", "event", "telefono", "click", "llamada");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });
  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "email",
          event_label: "envio",
        });
        gtag("event", "click_email");
      }
      if (typeof ga == "function") {
        ga("send", "event", "email", "click", "envio");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "whatsapp",
          event_label: "envio",
        });
        gtag("event", "click_whatsapp");
      }
      if (typeof ga == "function") {
        ga("send", "event", "whatsapp", "click", "envio");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "whatsapp",
          event_label: "envio",
        });
        gtag("event", "click_whatsapp");
      }
      if (typeof ga == "function") {
        ga("send", "event", "whatsapp", "click", "envio");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="m.me"]').forEach((element) => {
    element.classList.add("link-messenger");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "messenger",
          event_label: "envio",
        });
        gtag("event", "click_messenger");
      }
      if (typeof ga == "function") {
        ga("send", "event", "messenger", "click", "envio");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "messenger" });
      }
    });
  });
  document.querySelectorAll('a[href*="maps"]').forEach((element) => {
    element.classList.add("link-map");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "click", {
          event_category: "maps",
          event_label: "envio",
        });
        gtag("event", "click_mapa");
      }
      if (typeof ga == "function") {
        ga("send", "event", "maps", "click", "envio");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "maps" });
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", (event) => {
  // Crear una instancia de MutationObserver
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // Verificar si se agregaron nodos
      if (mutation.addedNodes) {
        mutation.addedNodes.forEach(function (node) {
          // Verificar si el nodo es un elemento
          if (node.nodeType === 1) {
            // Ejecutar tu código existente
            const items = $(node).find("li.t4s-menu-item a[data-img]");

            items.each(function (index, item) {
              const menu_parent = $(item).closest(".t4s-sub-menu");
              const banner_container = menu_parent.find(".t4s-banner-item");
              const img_banner = banner_container.find("img.img-banner");
              const subtext_banner = banner_container.find(
                "span.img-banner-subtext"
              );
              const currentImg = img_banner.attr("src");
              const img = $(item).attr("data-img");
              preloadImage(img);

              $(item).on("mouseenter", function (event) {
                const img = $(item).attr("data-img");
                $(subtext_banner).empty().html(item.innerHTML);
                img_banner.attr("src", img);
              });

              $(item).on("mouseleave", function (event) {
                img_banner.attr("src", currentImg);
                $(subtext_banner).empty();
              });
            });
          }
        });
      }
    });
  });

  // Configurar el observador para observar todo el documento y sus descendientes
  observer.observe(document, { childList: true, subtree: true });

  const badgeCommingSoon = document.querySelector(
    ".t4s-main-product__content[data-comming-soon]"
  );
  const badgesWrapper = document.querySelector(".t4s-single-product-badge");
  if (badgeCommingSoon !== null) {
    const badgeText = badgeCommingSoon.getAttribute("data-comming-soon-text");
    const badgeBGColor = badgeCommingSoon.getAttribute("data-comming-soon-bg");
    const badgeTextColor = badgeCommingSoon.getAttribute(
      "data-comming-soon-colortext"
    );
    const badgeElement = document.createElement("span");
    badgeElement.setAttribute("data-badge-comming-soon", "");
    badgeElement.classList.add("t4s-badge-item", "t4s-badge-commingsoon");
    badgeElement.style.backgroundColor = badgeBGColor;
    badgeElement.style.color = badgeTextColor;
    badgeElement.innerHTML = badgeText;
    setTimeout(() => {
      badgesWrapper.appendChild(badgeElement);
    }, 1000);
  }
});

function preloadImage(imgUrl) {
  const img = new Image();
  img.src = imgUrl;
}
